import { Badge } from "@mantine/core";

export default function RequirementLevelBadge({ attrib }) {
  let color = "gray";
  switch (attrib.requirementLevel) {
    case "REQUIRED":
      color = "red";
      break;
    case "OPTIONAL":
      color = "green";
      break;
    case "RECOMMENDED":
      color = "blue";
      break;
  }
  return (
    <Badge color={color} variant="outline">
      {attrib.requirementLevel}
    </Badge>
  );
}
